import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

type ModuleLandingHeroProps = {
  greeting: string
  subtitle?: string
  promptSlot?: ReactNode
  actions?: ReactNode
  className?: string
  dataTestId?: string
}

/** Shared hero for BuilderLanding modules (Flows, Dash). */
export function ModuleLandingHero({
  greeting,
  subtitle,
  promptSlot,
  actions,
  className,
  dataTestId,
}: ModuleLandingHeroProps) {
  return (
    <section
      className={cn("flex flex-col items-center gap-4 px-4 py-8 text-center", className)}
      data-testid={dataTestId}
    >
      <div className="max-w-2xl space-y-2">
        <h1 className="text-3xl font-semibold tracking-tight md:text-4xl">{greeting}</h1>
        {subtitle && <p className="text-muted-foreground text-base">{subtitle}</p>}
      </div>
      {promptSlot && <div className="w-full max-w-2xl">{promptSlot}</div>}
      {actions && <div className="flex flex-wrap items-center justify-center gap-3">{actions}</div>}
    </section>
  )
}
